import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSolarPanel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSolarPanel"><Path d="M12.7501 15H21.1564L20.1564 9.75H12.7501V15Z" fill="currentColor"/><Path d="M11.2501 15H12.7501V19.5H20.0001V21H4.00009V19.5H11.2501V15Z" fill="currentColor"/><Path d="M11.2501 15V9.75H3.84375L2.84375 15H11.2501Z" fill="currentColor"/><Path d="M12.7501 8.25H19.8707L18.8707 3H12.7501V8.25Z" fill="currentColor"/><Path d="M11.2501 3V8.25H4.12946L5.12946 3H11.2501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSolarPanel;
